import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { injectIntl } from 'react-intl';
import 'react-dates/initialize';
import { DateRangePicker as DateRange } from 'react-dates';
import s from  'react-dates/lib/css/_datepicker.css';

//Components
import messages from '../../../locale/messages';

//Helpers
import { isRTL } from '../../../helpers/formatLocale';
import withStyles from 'isomorphic-style-loader/withStyles';
class DateRangePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            focusedInput: false,
            startDate: null,
            endDate: null,
            smallDevice: false,
        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        let isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
        }
    }

    componentWillUnmount() {
        let isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
            window.removeEventListener('resize', this.handleResize);
        }
    }

    handleResize(e) {
        let isBrowser = typeof window !== 'undefined';
        let smallDevice = isBrowser ? window.matchMedia('(max-width: 767px)').matches : false;
        this.setState({ smallDevice });
    }

    onDatesChange = ({ startDate, endDate }) => {
        const { formName, change } = this.props;
        this.setState({ startDate, endDate });
        if (startDate && endDate) {
            change(formName, "startDate", moment(startDate).format("YYYY-MM-DD"));
            change(formName, "endDate", moment(endDate).format("YYYY-MM-DD"));
        }
    }

    onFocusChange = (focusedInput) => {
        const { startDate, endDate } = this.state;
        const { formName, change } = this.props;
        this.setState({ focusedInput });
        if (startDate && !endDate && !focusedInput) {
            this.setState({ endDate: startDate });
            change(formName, "endDate", moment(startDate).format("YYYY-MM-DD"));
            change(formName, "startDate", moment(startDate).format("YYYY-MM-DD"));
        }
        if (endDate && !startDate && !focusedInput) {
            this.setState({ startDate: endDate });
            change(formName, "startDate", moment(endDate).format("YYYY-MM-DD"));
            change(formName, "endDate", moment(endDate).format("YYYY-MM-DD"));
        }
    };

    render() {
        const { placeholder, locale, containerClass } = this.props;
        const { formatMessage } = this.props.intl;
        const { focusedInput, startDate, endDate, smallDevice } = this.state;

        return (
            <div>
                <DateRange
                    {...this.props}
                    onDatesChange={this.onDatesChange}
                    onFocusChange={this.onFocusChange}
                    focusedInput={focusedInput}
                    startDate={startDate}
                    endDate={endDate}
                    placeholder={placeholder}
                    readOnly
                    id={'DatePickerId'}
                    startDateId={"startDateId"}
                    endDateId={"endDateId"}
                    numberOfMonths={smallDevice ? 1 : 2}
                    startDatePlaceholderText={formatMessage(messages.startDateLabel)}
                    endDatePlaceholderText={formatMessage(messages.endDateLabel)}
                    hideKeyboardShortcutsPanel
                    transitionDuration={0}
                    anchorDirection={isRTL(locale) ? 'right' : 'left'}
                    isRTL={isRTL(locale)}
                    minimumNights={0}
                    isOutsideRange={() => false}
                    displayFormat ={"DD-MM-YYYY"}
                    daySize={smallDevice ? 36 : 38}
                />
            </div>
        );
    }
}

const mapState = state => ({
    locale: state.intl.locale
});

const mapDispatch = {
    change
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(DateRangePicker)));


